var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5Z",
    stroke: "url(#paint0_linear_379_2828)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6V12L15 15",
    stroke: "url(#paint1_linear_379_2828)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_379_2828",
    x1: 12.0049,
    y1: -8.94144,
    x2: 12.0049,
    y2: 27.0957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_379_2828",
    x1: 13.5007,
    y1: 1.5251,
    x2: 13.5007,
    y2: 16.9696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00902,
    stopColor: "#F6CD66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0391861,
    stopColor: "#DCAE4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0707524,
    stopColor: "#C8963B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1039,
    stopColor: "#B9852D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1397,
    stopColor: "#B17A26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1829,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3046,
    stopColor: "#CE9E45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4244,
    stopColor: "#E8BF61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4902,
    stopColor: "#F2CB6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5439,
    stopColor: "#ECC466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    stopColor: "#DDB155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7132,
    stopColor: "#C3923A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    stopColor: "#AE7723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8178,
    stopColor: "#B27C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8661,
    stopColor: "#BF8B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9189,
    stopColor: "#D3A446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9745,
    stopColor: "#F0C660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD86E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d4f3bbc3e31a4776eb1a653430d2f951.svg";
export { ForwardRef as ReactComponent };